import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  async getCoupons() {
    const response = await axios.get(`${API_URL}/coupons`, { headers: authHeader() })
    return response.data;
  },

  async updateCoupon(id, couponDTO) {
    const response = await axios.put(`${API_URL}/coupon/${id}`, couponDTO, { headers: authHeader() })
    return response.data;
  },

  async getTiposIngreso(appId) {
    //
    const response = await axios.get(`${API_URL}/app/${appId}/tipoIngreso`)
    return response.data;
  },
  async listaProductos(userId) {
    //, { headers: authHeader() }
    const response = await axios.get(`${API_URL}/app/user/${userId}/productos`)
    return response.data;
  },
  async insertProducto(req) {
    
    const postUrl = API_URL + "/app/producto";
    const response = await axios.post(postUrl,
      req,
      //{ headers: { 'Content-Type': 'application/json' } }
    );

    const responseObj = {
      id: response.data.id,
      ...req
    };

    return responseObj;
  },
  async deleteProducto(productoId) {
    
    const url = API_URL + `/app/producto/${productoId}`;
    await axios.delete(url
      //{ headers: { 'Content-Type': 'application/json' } }
    );

    return productoId;
  }
}